
/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = SKURepricingItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SKURepricingItemsEditor extends _Ext.ItemGridEditor<SKURepricingItemsRow> {


        protected getColumnsKey() { return "Inventory.SKURepricingItems"; }
        protected getDialogType() { return SKURepricingItemsDialog; }
        protected getLocalTextPrefix() { return SKURepricingItemsRow.localTextPrefix; }
        protected form: SKURepricingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        public TotalItems: number;
        // #endregion 
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: false });
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion 
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***

            if (field === fld.Weight) {
                if (item.CalcOnId != 3 && item.HasBom == false) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.UnitRate + labr) * value;
                    item.NetAmount = Net;
                    item.NetWeight = value;
                    item.GrossAmount = Net;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        //Set Data for New SKU Generated
        public setData(details: SKURepricingDetailsRow[]) {

            for (var i = 0; i < details.length; i++) {
                var items = [];
                var companyId = Q.Authorization.userDefinition.CompanyId;

                // #region Items to Grid

                details.forEach(function (Item: SKURepricingDetailsRow) {

                    let SKUDetail  ;

                    if (SKUDetail == null)
                        Purchase.PurchaseItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Purchase.ApprovalInItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Inventory.OpeningStockItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });


                    var x = SKUDetail;



                    if (SKUDetail != null && SKUDetail.LaborDetails != null) {
                        for (let k of SKUDetail.LaborDetails) {
                            delete k.TransItemId;
                            delete k.TransLbrId;
                        }
                    }

                    var bomdetails = [];
                    for (var i = 0; i < Item.BOMDetails.length; i++) {
                        var oldbom = Item.BOMDetails[i];
                        var bom: SKURepricingBOMRow = {

                            RefTransBomId: oldbom.RefTransBomId,
                            ProductId: oldbom.ProductId,
                            BOMProductId: oldbom.BOMProductId,
                            BOMAttributeId: oldbom.BOMAttributeId,
                            Lab: oldbom.Lab,
                            CertificateNo: oldbom.CertificateNo,
                            Pieces: oldbom.Pieces,
                            Weight: oldbom.Weight,
                            CalcOnId: oldbom.CalcOnId,
                            SettingId: oldbom.SettingId,
                            BomRate: 0,
                            SBomRate: 0,
                            BomAmount: 0,
                            CCBomAmount: 0,
                            Remarks: oldbom.Remarks,
                            Purity: oldbom.Purity,
                            PureWeight: oldbom.PureWeight,
                            ProductCode: oldbom.ProductCode,
                            ProductName: oldbom.ProductName,
                            IsCustomerItem: oldbom.IsCustomerItem,
                            ItemType: oldbom.ItemType,
                            CostMethodId: oldbom.CostMethodId,
                            CalcOn: oldbom.CalcOn,
                            ItemTypeId: oldbom.ItemTypeId,
                            ProductTypeId: oldbom.ProductTypeId,
                            SubCategoryId: oldbom.SubCategoryId,
                            CategoryId: oldbom.CategoryId,
                            ProductTypeName: oldbom.ProductTypeName,
                            CategoryName: oldbom.CategoryName,
                            SubCategoryName: oldbom.SubCategoryName,
                            Attribute: oldbom.Attribute,
                            SieveId: oldbom.SieveId,
                            GroupSieveId: oldbom.GroupSieveId,
                            TextureId: oldbom.TextureId,
                            Parts: oldbom.Parts
                        }
                        bomdetails.push(bom);
                    }
                    var detail: SKURepricingItemsRow = {
                        ProductId: Item.ProductId,
                        AttributeId: Item.AttributeId,
                        Line_No: Item.Line_No,
                        PartyId: Item.PartyId,
                        SKU: Item.SKU,
                        DepartmentId: Item.DepartmentId,
                        ProductCode: Item.ProductCode,
                        ProductName: Item.ProductName,
                        ItemTypeId: Item.ItemTypeId,
                        CategoryId: Item.CategoryId,
                        ProductTypeId: Item.ProductTypeId,
                        SubCategoryId: Item.SubCategoryId,
                        BrandId: Item.BrandId,
                        SuperTypeId: Item.SuperTypeId,
                        CollectionId: Item.CollectionId,
                        UnitRate: 0,
                        Pieces: Item.Pieces,
                        Weight: Item.Weight,
                        OtherPieces: Item.OtherPieces,
                        OtherWeight: Item.OtherWeight,
                        StonePieces: Item.StonePieces,
                        StoneWeight: Item.Stoneweight,
                        NetWeight: Item.NetWeight,
                        NetAmount: 0,
                        GrossAmount: 0,
                        DiamondPieces: Item.DiamondPieces,
                        DiamondWeight: Item.DiamondWeight,
                        CalcOnId: Item.CalcOnId,
                        CompanyId: companyId,
                        CostMethodId: Item.CalcOnId,
                        TransId: Item.TransId,
                        BOMDetails: bomdetails,
                        HasBom: Item.HasBom,
                        BagNo: Item.BagNo,
                        LotNo: Item.LotNo,
                        CertificateNo: Item.CertificateNo,
                        Lab: Item.Lab,
                        RefTransId: Item.RefTransId,
                        RefTransItemId: Item.RefTransItemId,
                        RefVoucherId: Item.RefVoucherId,
                        DesignId: Item.DesignId,
                        UnitCost: 0,
                        Studded: Item.Studded,
                        RefNo: Item.RefNo,
                        LaborDetails: SKUDetail != null ? SKUDetail.LaborDetails : [],
                        MF: 0,
                        MFAmount: 0,
                        HSN: Item.Hsn,
                        MetalColorId: Item.MetalColorId,
                        MetalId: Item.MetalId,
                        Purity: Item.Purity,
                        PureWeight: Item.PureWeight,
                        KaratId: Item.KaratId,
                        Hallmark: Item.Hallmark,
                        Parts: Item.Parts == null ? 1 : Item.Parts,
                        ExportPieces: Item.ExportPieces
                    };
                    items.push(detail);

                });

                for (let Item of items) {
                    Item[this.getIdProperty()] = "`" + this.nextId++;
                    this.view.addItem(Item);
                }
            }
        }

        public setOldItems(entity: any[]) {
            for (var i = 0; i < entity.length; i++) {
                entity[i][this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(entity[i]);
            }
        }
        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            return buttons;
        }



        // #endregion




    }
}